import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetUserLongTasksResponse } from "./GetUserLongTasksResponse";

const ENDPOINT = "/user_long_task";

export class GetUserLongTasksCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    public async execute(): Promise<GetUserLongTasksResponse> {
        var res = await this.executeCommand();
        return new GetUserLongTasksResponse(res);
    }
}
